export enum Frequency {
  Inactive = 'Inactive',
  ManualLaunch = 'Manual Launch',
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly',
  Custom = 'Custom',
}
